module.exports = __webpack_public_path__ + "img/16.ba6b34f3.png";